import RtwImageType from "./actionTypes"

const INIT_STATE = {
  pageData: {
    loading: true,
    data: {}
  },
  detail: {
    loading: false,
    data: {}
  },
  saved: {
    loading: false
  }
}

const RtwImage = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RtwImageType.GET_RTW_IMAGE_PAGES_SUCCESS:
      return {
        ...state,
        pageData: action.payload,
      }

    case RtwImageType.GET_DETAIL_RTW_IMAGE_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload,
      }

    case RtwImageType.PUT_RTW_IMAGE_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case RtwImageType.POST_RTW_IMAGE_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    default:
      return state
  }
}

export default RtwImage
